(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("react-phone-number-input", ["React"], factory);
	else if(typeof exports === 'object')
		exports["react-phone-number-input"] = factory(require("React"));
	else
		root["react-phone-number-input"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 